import RequirePhysicianOrMasterUserMiddleware from 'middlewares/RequirePhysicianOrMasterUserMiddleware'
import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'
import RequireSignupFinishedMiddleware from 'middlewares/RequireSignupFinishedMiddleware'

export default [
    {
        path: '/profile',
        name: 'profile',
        view: 'profile/Profile',
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrMasterUserMiddleware, RequireUserMiddleware],
    },
    {
        path: '/profile/user/:id',
        name: 'profile.user',
        view: 'profile/Preview',
        middlewares: [RequireSignupFinishedMiddleware, RequireUserMiddleware],
    },
]
